import ResponseCodes from '@/docs-partials/api/response-codes.mdx';
import * as React from 'react';
export default {
  ResponseCodes,
  React
};